<!-- <app-spinner-container [isLoading]="ondelete">
    <table 
    matSort 
    (matSortChange)="onSortChange($event)"
      [dataSource]="dataSource"
      mat-table
      
      style="width: 100%"
    >
      <ng-container *ngFor="let column of readColumns" [matColumnDef]="column" >
        <th *matHeaderCellDef mat-header-cell mat-sort-header  >
          {{ labels[column] | translate }}
        </th>
        <td *matCellDef="let type" mat-cell translate >
    {{ type[column] | typedValue | async | translate}}
        </td>
      </ng-container>
      <ng-container matColumnDef="action" style="align-items: center;">
        <th *matHeaderCellDef mat-header-cell ></th>
        <td *matCellDef="let projet" mat-cell  >
          <a (click)="detailprojet(projet)" mat-icon-button>
            <mat-icon style="color: #00a8ff;">info</mat-icon>
          </a>
          
        </td>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>

    <app-empty-list-container
    [list]="dataSource.data"
    [withoutBorder]="true"
></app-empty-list-container>
  </app-spinner-container> -->
<!-- <app-spinner-container [isLoading]="ondelete">
    <table 
    matSort 
    (matSortChange)="onSortChange($event)"
      [dataSource]="dataSource"
      mat-table
      
      style="width: 100%"
    >
      <ng-container *ngFor="let column of readColumns" [matColumnDef]="column" >
        <th *matHeaderCellDef mat-header-cell mat-sort-header  >
          {{ labels[column] | translate }}
        </th>
        <td *matCellDef="let type" mat-cell translate >
    {{ type[column] | typedValue | async | translate}}
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell ></th>
        <td *matCellDef="let offre" mat-cell>
          <a (click)="detailoffer(offre)" mat-icon-button>
            <mat-icon style="color: #00a8ff;">info</mat-icon>
          </a>

        </td>
      </ng-container>
      <tr *matHeaderRowDef="getlang()?displayedColumnsAR:displayedColumnsFR" mat-header-row></tr>
      <tr *matRowDef="let row; columns: getlang()?displayedColumnsAR:displayedColumnsFR" mat-row></tr>
    </table>
    <app-empty-list-container
    [list]="dataSource.data"
    [withoutBorder]="true"
></app-empty-list-container>
  </app-spinner-container> -->
  <!-- <app-offer [offer]="offer"></app-offer> -->

  <!-- <app-offer [offer]="offer"></app-offer> -->
  <table
  (matSortChange)="onSortChange($event)"
 
   [dataSource]="dataSource"
   
   mat-table
   matSort
   style="width: 100%"
 >
 <!-- <ng-container matColumnDef="action">
   <th *matHeaderCellDef mat-header-cell mat-sort-header>
    N°
   </th>
   <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
 </ng-container> -->
 
 <ng-container matColumnDef="shopNo">
   <th *matHeaderCellDef mat-header-cell mat-sort-header>
     {{ "N° consultation" | translate }}
   </th>
   <td *matCellDef="let d" mat-cell>{{ d.shopNo | typedValue | async | translate}}</td>
 </ng-container>
 
 
 
 <ng-container matColumnDef="instNm">
   <th  *matHeaderCellDef mat-header-cell mat-sort-header>
    
     {{ "Acheteur public" | translate }}
   </th>
   <td width="40%" *matCellDef="let d" mat-cell>
      {{d.instNm | typedValue | async | translate }}
    
     </td>
 </ng-container>
 
 <ng-container matColumnDef="publicDt">
   <th  *matHeaderCellDef mat-header-cell mat-sort-header>
     {{ "Date Publication" | translate }}
   </th>
   <td width="40%" *matCellDef="let d" mat-cell>
     {{ d.publicDt | typedValue | async | translate}}
      </td>
 </ng-container>
 <ng-container matColumnDef="shopNmFr">
   <th  *matHeaderCellDef mat-header-cell mat-sort-header>
     {{ "Objet Consultation" | translate }}
   </th>
   <td width="40%" *matCellDef="let d" mat-cell>
   {{d.shopNmFr | typedValue | async | translate}}
       </td>
 </ng-container>
 <ng-container matColumnDef="spRecvEndDt">
  <th  *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "Dernier Délai Réception Offres" | translate }}
  </th>
  <td width="40%" *matCellDef="let d" mat-cell>
  {{d.spRecvEndDt | dft | typedValue | async | translate}}
      </td>
</ng-container>
 
 <ng-container matColumnDef="spShopMasterId">
   <th   *matHeaderCellDef mat-header-cell mat-sort-header>
     {{ "Dernier Délai Soumissions Offres" | translate }}
   </th>
   <td  width="12%" *matCellDef="let d" mat-cell>{{ d.spShopMasterId |typedValue | async | translate }}</td>
 </ng-container>

 <ng-container matColumnDef="action" style="align-items: center;">
  <th *matHeaderCellDef mat-header-cell ></th>
  <td *matCellDef="let projet" mat-cell  >
    <a (click)="detailprojet(projet)" mat-icon-button>
      <mat-icon style="color: #00a8ff;">info</mat-icon>
    </a>
    
  </td>
</ng-container>
 
   <tr  *matHeaderRowDef="getcol()" mat-header-row></tr>
   <tr  *matRowDef="let row; columns: getcol()" mat-row></tr> 
   
    
 
 
   
 </table>
<app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
